/**
 * API base URL — barcha backend so'rovlari uchun.
 * Backend api.adde.app da (adde.app dan alohida).
 * .env: REACT_APP_API_URL yoki REACT_APP_API_BASE_URL.
 */
const DEFAULT_API_BASE = 'https://api.addegroup.uz';

function getApiBaseUrl() {
  const url =
    (typeof process !== 'undefined' && process.env?.REACT_APP_API_URL) ||
    (typeof process !== 'undefined' && process.env?.REACT_APP_API_BASE_URL);
  if (url && typeof url === 'string') {
    return String(url).trim().replace(/\/$/, '');
  }
  // Production/build da env bo'lmasa — api.adde.app ishlatiladi (adde.app ga emas)
  return DEFAULT_API_BASE;
}

export const API_BASE_URL = getApiBaseUrl();

/**
 * Path bilan to'liq mutlaq URL — har doim api.adde.app ga so'rov ketadi.
 */
export function buildAbsoluteUrl(path) {
  const base = API_BASE_URL;
  const p = path && path.startsWith('/') ? path : `/${path || ''}`;
  return `${base}${p}`;
}
